import React from 'react';
import { useNavigate } from 'react-router-dom';

function AdminPage() {
  const navigate = useNavigate();

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '70vh',
      textAlign: 'center',
    },
  };

  return (
    <div style={styles.container}>
      <h1>Админская панель</h1>
      <div className="tool__add__new_info add__buttons" onClick={() => navigate('/users')}>Редактор пользователей</div>
      <div className="tool__add__new_info add__buttons" onClick={() => navigate('/catalog')}>Редактор характеристик и справочников</div>
    </div>
  );
}

export {AdminPage};